<template>
  <div class="main-content">
    <h1>Videozóna</h1>
    <div class="heading-spliter"></div>
    <div class="text-mute">
      <p>Virtuálny priestor na profesionálny a osobnostný rozvoj zamestnancov. Všetky rozvojové videá vychádzajú z našich vzdelávacích konceptov a dlhoročného know-how.</p>
      <p>
        Videá, ktoré môžete začať sledovať, sa vám zobrazujú v časti:
        <b>Sprístupnené.</b>
      </p>
      <p>
        Videá, ktoré vám môžeme sprístupniť, sa nachádzajú v časti:
        <b>Na vyžiadanie.</b>
      </p>
    </div>
    <h2>Sprístupnené</h2>
    <video-groups-list :video_groups="video_groups_accessible" />

    <h2>Na vyžiadanie</h2>
    <video-groups-list :video_groups="video_groups_unaccessible" />
  </div>
</template>


<script>
import VideoGroupsList from "./VideoGroupsList";

export default {
  components: {
    "video-groups-list": VideoGroupsList
  },
  data() {
    return {
      video_groups_accessible: null,
      video_groups_unaccessible: null
    };
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$api.server
        .get(
          "api/public/video-groups/all?accessible=1&lang_id=" +
            this.$api.translator.getCurrent()
        )
        .then(r => {
          this.video_groups_accessible = r.data.video_groups;
          this.video_groups_accessible = this.video_groups_accessible.map(
            video_group => ({
              ...video_group,
              thumb:
                this.$api.server.prependServerUrl(
                  "storage/" + video_group.thumb
                ),
              first_video_id:
                video_group.videos &&
                video_group.videos[0] &&
                video_group.videos[0].id
            })
          );
        });

      this.$api.server
        .get(
          "api/public/video-groups/all?accessible=0&lang_id=" +
            this.$api.translator.getCurrent()
        )
        .then(r => {
          this.video_groups_unaccessible = r.data.video_groups;
          this.video_groups_unaccessible = this.video_groups_unaccessible.map(
            video_group => ({
              ...video_group,
              thumb:
                this.$api.server.prependServerUrl(
                  "storage/" + video_group.thumb
                ),
              first_video_id:
                video_group.videos &&
                video_group.videos[0] &&
                video_group.videos[0].id
            })
          );
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/public_app/pages/videozone/List.vue